// StepBar configuration
// #stepbar-item-{STAGE} to select as current step on stage insertion
export default {
  identity: {
    step: 'identity',
  },
  security: {
    step: 'security',
  },
  polling: {
    step: 'security',
  },
};
